import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Stack,
} from '@mui/material';
import { Summary } from './Summary';
import { ContactInformation } from './ContactInformation';
import { Details } from './Details';
import { InstituteAlert } from './InstituteAlert';
import { useIsDesktop } from 'Hooks';
import { ISuppliersResult } from 'API/Suppliers/suppliers';
import { useEffect, useState } from 'react';
import { OpenClose } from './OpenClose';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

interface ITherapy {
  data: ISuppliersResult;
  isAlwaysOpen?: boolean;
}

export const Therapy = ({ data, isAlwaysOpen }: ITherapy) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const isDesktop = useIsDesktop();

  const hasDetailsData =
    data.treatmentMethods.length > 0 ||
    data.languages.length > 0 ||
    (data.instituteId && data.instituteId !== '') ||
    data.hasHomeVisit;

  useEffect(() => {
    setIsOpen(false);
  }, [data]);

  return (
    <Accordion
      expanded={isAlwaysOpen ? isAlwaysOpen : isOpen}
      onClick={() => (isAlwaysOpen ? undefined : hasDetailsData)}
      onKeyDown={onEnterOrEscapeKeyDown}
      sx={{
        width: '100%',
        p: isDesktop ? '24px 24px 32px 24px' : '24px 16px',
        bgcolor: '#FFF',
        borderRadius: '16px',
        border: '1px solid',
        borderColor: 'primary.shade_100',
        boxShadow: 'none',
        '&:before': { display: 'none' },
        ':hover': {
          cursor: 'default',
        },
      }}
    >
      <AccordionSummary
        expandIcon={null}
        tabIndex={-1}
        sx={{
          p: 0,
          cursor: 'default !important',
          userSelect: 'text',
        }}
        role={undefined}
        aria-expanded={undefined}
      >
        <Stack>
          <Summary data={data} />
          {isDesktop && (
            <Divider
              orientation='horizontal'
              sx={{ m: '16px 0 24px 0', borderColor: 'primary.shade_200' }}
              aria-hidden={true}
            />
          )}
          <ContactInformation
            data={data}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            isAlwaysOpen={isAlwaysOpen}
            hasDetailsData={hasDetailsData}
          />
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <Details data={data} />
        {data.instituteId && data.instituteId !== '' && (
          <InstituteAlert instituteName={data.instituteName} />
        )}
        {isAlwaysOpen
          ? null
          : !isDesktop && (
              <OpenClose
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                hasDetailsData={hasDetailsData}
              />
            )}
      </AccordionDetails>
    </Accordion>
  );
};
